module.exports = __webpack_public_path__ + "img/layer-bg_02.96be0346.jpg";